import { AutogenLayoutBreakthroughFuelDetail } from "./autogen/AutogenLayoutBreakthroughFuelDetail";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class BreakthroughFuelDetail extends AutogenLayoutBreakthroughFuelDetail {

    /** This is an event handler for the afterExecution event of sourceBreakthroughTransaction. */
    sourceBreakthroughTransactionAfterExecution(event: DataSourceExecutionEvent) {
        const orderId = this.activeRow.get("order_id");
        if (orderId) {
            this.activeRow.setLookupModelData("order_id", { id: orderId });
        }
    }
}
